import React from "react";
import PropTypes from "prop-types";

import "./SettingsLayout.scss";

const SettingsPanel = ({ title, description, children }) => (
    <div className="settings-panel">
        <header className="settings-panel__header">
            <h2>{title}</h2>
            {description && <p>{description}</p>}
        </header>
        <div className="settings-panel__body">
            {children}
        </div>
    </div>
);

SettingsPanel.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    children: PropTypes.node.isRequired,
};

SettingsPanel.defaultProps = {
    description: "",
};

export default SettingsPanel;
